import React from 'react'
import ReactDOM from 'react-dom/client'
import {
	Provider
}from 'react-redux'

import {
	store
}from './store'
import reportWebVitals from './reportWebVitals'

import App from './App'

import './index.css'

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(<Provider store={ store }>
	<App />
</Provider>)

// If you want to start measuring performance in your app, pass a function
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
